import { EventsScreen } from '@/components/domain/events/EventsScreen';

export default function EventsNearby() {
  return <EventsScreen initialListType="nearby" />;
}
